<div
  *transloco="let t; prefix: 'save-to-collection-dialog'"
  class="xi-modal__container save-to-collection__container"
>
  @if (isLoading()) {
    <div class="save-to-collection__loader">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }

  <h2 class="xi-modal__title save-to-collection__title">{{ t('save-to-collection') }}</h2>

  <div class="xi-modal__content save-to-collection__content">
    @switch (state()) {
      @case ('START') {
        <div>
          <form autocomplete="off">
            @if (destinationType() === 'EXISTING') {
              <p class="kxi-text-normal save-to-collection__label">
                {{ t('choose-collection') }}
              </p>

              <table
                mat-table
                [dataSource]="dataSource()"
                matSort
                matSortDisableClear
                class="save-to-collection__table"
              >
                <ng-container matColumnDef="displayName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="flex-end">
                    {{ t('name') }}
                  </th>

                  <td mat-cell *matCellDef="let element">
                    <ng-container
                      *appMiddleEllipsize="element.displayName; align: 'end'"
                    ></ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="analysisCount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="flex-end">
                    {{ t('analyses') }}
                  </th>

                  <td mat-cell *matCellDef="let element">{{ element.analysisCount }}</td>
                </ng-container>

                <ng-container matColumnDef="documentCount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="flex-end">
                    {{ t('documents') }}
                  </th>

                  <td mat-cell *matCellDef="let element">
                    {{ element.documentCount | humanizeInt }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="analysisType">
                  <th mat-header-cell *matHeaderCellDef>{{ t('method') }}</th>

                  <td mat-cell *matCellDef="let element">
                    @if (element.isAutoAnalyze) {
                      {{ t('auto-analysis') }}

                      <br />

                      <ng-container
                        *appMiddleEllipsize="configNamesById.get(element.configId); align: 'end'"
                      ></ng-container>
                    } @else {
                      {{ t('manual') }}
                    }
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                  [class.disabled]="isRowDisabled(row)"
                  [class.save-to-collection-dialog__collection--selected]="
                    target() === row.collectionName && !row.locked
                  "
                  [matTooltip]="
                    isRowDisabled(row)
                      ? row.locked
                        ? t('collection-locked')
                        : t('add-to-collection-disabled')
                      : ''
                  "
                  (click)="toggleSelectedCollection(row)"
                ></tr>
              </table>
            }

            @if (destinationType() === 'NEW' && !isLoading()) {
              <div class="save-to-collection__new">
                @if (!newCollection()?.locked) {
                  <xi-input-field
                    [label]="t('collection-name')"
                    [placeholder]="t('enter-here')"
                    name="newTargetCollectionDisplayName"
                    [ngModel]="target()"
                    (ngModelChange)="target.set($event)"
                    [status]="collectionNameStatus()"
                    [disabled]="newCollection()?.locked"
                    (onChange)="onValidateCollectionName()"
                    (onInputEnter)="confirm()"
                    required
                  ></xi-input-field>
                }

                @if (newCollection()?.locked) {
                  <div class="save-to-collection__locked-collection">
                    {{ t('collection-locked') }}
                  </div>
                }
              </div>
            }
          </form>
        </div>
      }

      @case ('COPYING') {
        <div class="save-to-collection__copying">
          <p>
            {{ t('documents-being-copied') }}
            <em>{{ targetDisplayName() }}</em>
          </p>
          <mat-progress-bar mode="buffer"></mat-progress-bar>
        </div>
      }

      @case ('COMPLETE') {
        <div>
          <p>{{ t('all-documents-copied') }}</p>
        </div>
      }

      @case ('ERROR') {
        <div>
          <p>
            {{ t('error-copy') }}
          </p>
        </div>
      }
    }
  </div>

  <div class="xi-modal__actions save-to-collection__actions">
    @if (state() === 'START') {
      <div>
        <xi-default-button
          [text]="t('cancel')"
          fill="text"
          (onClick)="cancel()"
        ></xi-default-button>
      </div>
    }

    <div class="fill-space"></div>

    @if (state() === 'ERROR') {
      <div>
        <xi-default-button
          [text]="t('close')"
          [disabled]="hasError()"
          (onClick)="close()"
        ></xi-default-button>
      </div>
    }

    @if (state() === 'START') {
      <div>
        <xi-default-button
          [text]="destinationType() === 'EXISTING' ? t('add') : t('create')"
          [disabled]="hasError()"
          (onClick)="confirm()"
        ></xi-default-button>
      </div>
    }
  </div>
</div>
